/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFilterFunnelIcon24Solid = forwardRef('UiFilterFunnelIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M20.5 3h-17A1.5 1.5 0 0 0 2 4.5v2.728c0 .485.234.94.628 1.22l5.953 4.253a1 1 0 0 1 .419.814v7.744a1 1 0 0 0 1.504.864l4-2.334a1 1 0 0 0 .496-.863v-5.411a1 1 0 0 1 .419-.814l5.953-4.252A1.5 1.5 0 0 0 22 7.229V4.5A1.5 1.5 0 0 0 20.5 3Z" })));
});
